import { Divider } from "@mui/material";
import { styled } from "@mui/material/styles";

export const Card = styled("div")(() => ({
  display: "flex",
  flexDirection: "column",
  justifyContent: "flex-start",
  alignItems: "flex-start",
  minHeight: "188px",
  background: "#F9FAFB",
  border: "1px solid #E4E7EC",
  borderRadius: "12px",
}));

export const CardTitle = styled("div")(() => ({
  fontFamily: "Manrope",
  fontStyle: "normal",
  fontWeight: 600,
  fontSize: "22px",
  lineHeight: "28px",
  padding: "16px 16px 0 16px",
  minHeight: "60px",
}));

export const CardBody = styled("div")(() => ({
  width: "100%",
}));

export const AddressItem = styled("div")(() => ({
  width: "100%",
  padding: "16px",
  display: "flex",
  flexDirection: "row",
  justifyContent: "space-between",
  minHeight: "81px",
}));

export const AddressItemTitle = styled("label")(() => ({
  fontFamily: "Manrope",
  fontStyle: "normal",
  fontWeight: 600,
  fontSize: "12px",
  lineHeight: "16px",
  color: "#475467",
}));

export const AddressItemInfo = styled("div")(() => ({
  fontFamily: "Manrope",
  fontStyle: "normal",
  fontWeight: 400,
  fontSize: "16px",
  lineHeight: "24px",
  color: "#475467",
}));

export const AddressItemDivider = styled(Divider)(() => ({
  width: "100%",
  color: "#E4E7EC",
}));

export const CardFooter = styled("div")(() => ({
  display: "flex",
  justifyContent: "flex-end",
  alignItems: "center",
  padding: "16px",
  width: "100%",
  paddingTop: "auto",
  height: "72px",
}));
